import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, ListItem, ListItemText } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { I18n } from 'react-redux-i18n';

// Ligne produit du navigateur. Une pastille « Configuré » signale qu'un binding
// existe. En mode normal la ligne ouvre la popup de configuration ; en mode
// sélection multiple elle coche/décoche le produit (checkbox + surbrillance).
const ProductRow = React.memo(props => {
	const { id, name, configured, count, onClick, selectable, selected } = props;

	return (
		<ListItem
			button
			onClick={() => onClick(id)}
			className={
				'binding-product-row' +
				(selectable && selected ? ' binding-product-row-selected' : '')
			}>
			{selectable ? (
				<Checkbox
					color="primary"
					checked={!!selected}
					className="binding-product-check"
					tabIndex={-1}
					disableRipple
				/>
			) : null}
			<ListItemText
				primary={
					<div className="binding-product-line">
						<span className="binding-product-name">{name}</span>
						{configured ? (
							<span className="binding-product-pill">
								{I18n.t('settings.binding.configured_count', { count })}
							</span>
						) : null}
					</div>
				}
				primaryTypographyProps={{
					style: { fontFamily: 'FuturaBook', fontSize: 15 },
				}}
			/>
			{selectable ? null : (
				<ChevronRightIcon className="binding-product-chevron" />
			)}
		</ListItem>
	);
});

ProductRow.propTypes = {
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	name: PropTypes.string.isRequired,
	configured: PropTypes.bool,
	count: PropTypes.number,
	onClick: PropTypes.func.isRequired,
	// mode sélection multiple : affiche une checkbox et gère la surbrillance
	selectable: PropTypes.bool,
	selected: PropTypes.bool,
};

export default ProductRow;
